import { BOI_THEME_TOKENS, NEW_IRELAND_THEME_TOKENS } from "./constants";
import type { Brand, ScalableSizeToken } from "./types";

export function getThemeTokens(brand: Brand) {
  if (brand === "boi") {
    return BOI_THEME_TOKENS;
  }

  if (brand === "newIreland") {
    return NEW_IRELAND_THEME_TOKENS;
  }

  return BOI_THEME_TOKENS;
}

export { getBrandThemes } from "../../design-tokens/utils";

function isScalableSizeToken(
  value: unknown
): value is ScalableSizeToken<string> {
  if (value && typeof value === "object" && "size" in value) {
    if (typeof value.size !== "string") {
      console.warn("Unexpected ScalableSizeToken size property type");
    }
    return true;
  }
  return false;
}
export function parseSizeToken(token: string | number | ScalableSizeToken) {
  if (isScalableSizeToken(token)) {
    const { size, maxSize, minSize } = token;
    if (minSize && maxSize) {
      return `clamp(${minSize}, ${size}, ${maxSize})`;
    } else if (maxSize) {
      return `min(${size}, ${maxSize})`;
    } else if (minSize) {
      return `max(${minSize}, ${size})`;
    }
    return size;
  }
  if (typeof token === "string") {
    return token;
  }
  if (typeof token === "number") {
    throw new Error(`Unexpected unitless size token "${token}"`);
  }

  throw new Error(`Unexpected Size Token value "${JSON.stringify(token)}"`);
}
